/* eslint-disable */
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"
import { clFarmAbi } from "@/domains/abis"

import type { TransactionReturnType } from "../types"
import { simulatedTransaction } from "../simulated-transaction"

type UnstakeClFarmLiquidityProps = {
  account: Address
  chainId: number
  config: Config
  farmAddress: Address
  amount: bigint
}

export const unstakeClFarmLiquidity = async ({
  account,
  chainId,
  config,
  farmAddress,
  amount,
}: UnstakeClFarmLiquidityProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: clFarmAbi as Abi,
        account,
        address: farmAddress,
        args: [amount],
        chainId,
        functionName: "withdraw",
      },
    })
    return result
  } catch (error: any) {
    console.error("unstakeClFarmLiquidity", error)
    return { success: false, error: error.message, code: error.code }
  }
}
